import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "End__Inner section__inner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "End__Background color--1" }, null, -1)
const _hoisted_3 = { class: "End__Subinner section__subinner" }
const _hoisted_4 = { class: "End__Grid grid End__Main__Wrapper" }
const _hoisted_5 = { class: "End__Main" }
const _hoisted_6 = { class: "color--2" }
const _hoisted_7 = { class: "End__Main__Content" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 16 21" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-download-button" })
  ])
], -1)
const _hoisted_10 = { class: "End__Grid grid End__Visual__Wrapper" }
const _hoisted_11 = { class: "End__Visual" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "End__Visual__Background color--5" }, null, -1)
const _hoisted_13 = { class: "End__Grid grid End__Footer__Wrapper" }
const _hoisted_14 = { class: "End__Footer" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 64 64",
  class: "color--1"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "border",
    opacity: "0.3",
    cx: "32",
    cy: "32",
    r: "31.5"
  }),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("rect", {
      class: "alt",
      opacity: "0.5",
      width: "9.88718",
      height: "16.56",
      rx: "4.94359",
      transform: "matrix(0.991106 0.133077 -0.145537 0.989353 38.2012 24.3005)"
    })
  ]),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("rect", {
      class: "alt",
      opacity: "0.5",
      width: "9.88717",
      height: "16.56",
      rx: "4.94359",
      transform: "matrix(0.991097 -0.133139 0.145469 0.989363 16 25.6162)"
    })
  ]),
  /*#__PURE__*/_createElementVNode("rect", {
    class: "center",
    x: "25.1445",
    y: "21.25",
    width: "13.8694",
    height: "20.4082",
    rx: "6.93472",
    "stroke-width": "1.5"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TestEndProgress = _resolveComponent("TestEndProgress")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_LazyPicture = _resolveComponent("LazyPicture")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FocusTrap = _resolveComponent("FocusTrap")!

  return (_openBlock(), _createBlock(_component_FocusTrap, { active: _ctx.active }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass({ 'End': true, 'Test__End': true, 'active': _ctx.active })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_TestEndProgress, {
                    ref: "progress",
                    score: _ctx.result?.score || 0,
                    scoreForSuccess: _ctx.result?.scoreToReach || 50,
                    active: _ctx.active
                  }, null, 8, ["score", "scoreForSuccess", "active"]),
                  _createElementVNode("div", {
                    class: "End__Main__Text color--4",
                    innerHTML: _ctx.text
                  }, null, 8, _hoisted_8),
                  (_ctx.status === 'success')
                    ? (_openBlock(), _createBlock(_component_ButtonHover, {
                        key: 0,
                        download: "",
                        target: "_blank",
                        href: _ctx.result.certificateUrl,
                        class: "button button--color button--download color--2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9,
                          _createTextVNode(_toDisplayString(_ctx.$t('test.download')), 1)
                        ]),
                        _: 1
                      }, 8, ["href"]))
                    : (_openBlock(), _createBlock(_component_ButtonHover, {
                        key: 1,
                        class: "button button--color color--2",
                        to: `/test/${_ctx.test.slug}?try=${_ctx.tryCount}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('test.tryAgain')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_LazyPicture, {
                  class: "picture picture--appear picture--2",
                  image: _ctx.getImage(2),
                  alt: _ctx.title
                }, null, 8, ["image", "alt"]),
                _createVNode(_component_LazyPicture, {
                  class: "picture picture--appear picture--1",
                  image: _ctx.getImage(1),
                  alt: _ctx.title
                }, null, 8, ["image", "alt"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("footer", _hoisted_14, [
                _createVNode(_component_router_link, {
                  class: "End__Back",
                  to: '/courses'
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('chapter.back')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["active"]))
}